import { MultiGuard } from './async';

export class Mutex {
  private guard = new MultiGuard();
  private locked : boolean = false;

  constructor() { }

  async withLock<T>(f: () => Promise<T>) {
    while (this.locked) {
      await this.guard.wait();
    }

    this.locked = true;
    try {
      return await f();
    } finally {
      this.locked = false;
      this.guard.notifyAll();
    }
  }
}

